import { inject, Injectable } from '@angular/core';
import { DictType } from '@hglobal/utility-kit';

import { ApiEndpoint } from '../api';
import { environment } from '../environments/environment';
import { BrowserStorageKey } from '../shared/browser-storage/browser-storage.constant';
import { WINDOW } from '../shared/common';

import { SessionManagerEndpoint, SignInMethod } from './auth.constant';
import { AuthUtility } from './auth.utility';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private window = inject(WINDOW);

  handleSSOReturnRedirect(): void {
    const hasPendingRedirect = this.window.sessionStorage.getItem(BrowserStorageKey.IsAuthRedirectInProgress) === 'true';

    if (!hasPendingRedirect) {
      return;
    }

    this.window.sessionStorage.removeItem(BrowserStorageKey.IsAuthRedirectInProgress);
    this.window.localStorage.setItem(BrowserStorageKey.IsAuthenticated, 'true');
  }

  isSignedIn(): boolean {
    return this.window.localStorage.getItem(BrowserStorageKey.IsAuthenticated) === 'true';
  }

  isSignedOut(): boolean {
    return !this.isSignedIn();
  }

  login(method: DictType<typeof SignInMethod>): void {
    const loginUrl = AuthUtility.isSessionManagerMode()
      ? this.getSessionManagerLoginUrl(method)
      : this.getApiLoginUrl();

    this.window.sessionStorage.setItem(BrowserStorageKey.IsAuthRedirectInProgress, 'true');
    this.window.location.assign(loginUrl);
  }

  logout(): void {
    this.window.localStorage.removeItem(BrowserStorageKey.IsAuthenticated);
  }

  private getApiLoginUrl(): string {
    const returnRedirectUrl = this.window.location.origin;
    const url = new URL(`/${ApiEndpoint.OAuthLogin}`, environment.apiHost);

    url.searchParams.set('ui', 'true');
    url.searchParams.set('returnTo', returnRedirectUrl);

    return url.toString();
  }

  private getSessionManagerLoginUrl(method: DictType<typeof SignInMethod>): string {
    const endpoint = method === SignInMethod.CorporateSso
      ? SessionManagerEndpoint.CorporateSsoLogin
      : SessionManagerEndpoint.Login;

    return `${environment.auth.sessionManagerHost}/${endpoint}`;
  }
}
